export default {
  data() {
    return {
      UNIX_DATE: "1970-01-01"
    }
  },
  filters: {
    currency(value) {
      return this.formatCurrency(value);
    },
  },
  methods: {
    movePositionHubspotChatIcon(position) {
      setTimeout(() => {
        const hubSpotChatIcon = document.getElementById(
          "hubspot-messages-iframe-container"
        );

        if (hubSpotChatIcon)
          hubSpotChatIcon.style.setProperty("bottom", `${position}px`, "important");
      }, 3000);
    },
    formatCurrency(value) {
      if (!value) return 0;

      return Number(parseFloat(value).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    repositionBottomActions(otherContainers=[]) {
      // repositions the bottom actions of the page to avoid the hubspot chat icon
      setTimeout(() => {
        const hubspot_container = document.getElementById(
          "hubspot-messages-iframe-container"
        );
        const fixedBottomContainer = document.getElementsByClassName(
          "fixed-bottom-container"
        );

        if (hubspot_container) {
          if (fixedBottomContainer && fixedBottomContainer.length) {
            for(let i = 0; i < fixedBottomContainer.length; i++) {
              fixedBottomContainer[i].style.setProperty("padding-right", "calc(100px + 1.5rem)", "important");
            }
          }
          if(otherContainers.length) {
            for(let i = 0; i < otherContainers.length; i++) {
              otherContainers[i].style.setProperty("padding-right", "calc(100px + 1.5rem)", "important");
            }
          }
        }
      }, 1000);
    },
  }
}